import type { FaireProductEntity } from "../../entity_types/product";

export const apparel_sweater_green: FaireProductEntity = {
  token: "apparel-sweater-green",
  type: "product",
  name: "Vintage Crewneck Sweatshirt",
  brandName: "American Trench",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/0b3090aa07974618d1ec2187f1e96afe89d68ca3dc1f2fb1f1f8a7559f769ed8.jpeg",
  priceDollars: 42,
  msrpDollars: 85,
  freeShipping: true,
  weight: 1,
  dimensions: {
    width: 14,
    height: 18,
    depth: 2,
  },
  description:
    "Garment-dyed heavyweight fleece crewneck. Relaxed fit, brushed interior.",
  categoryTokens: ["cat_accessories"],
  tags: ["apparel", "sweater", "crewneck", "vintage"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
